import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
  List,
  ListItem,
  ListItemText,
  ListSubheader,
} from '@mui/material';
import { compact, join, map } from 'lodash';
import React from 'react';

import { SlideInferenceResults } from 'interfaces/calculateFeatures';

interface Props {
  flowClassName: string;
  slideIds: string[];
  slideDetailsById?: Record<string, SlideInferenceResults>;
}

const MultiplexProcessSlideIds: React.FunctionComponent<React.PropsWithChildren<Props>> = ({
  flowClassName,
  slideIds,
  slideDetailsById,
}) => {
  return (
    <Accordion disableGutters>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>{flowClassName}</AccordionSummary>
      <AccordionDetails>
        <List
          component="div"
          sx={{
            pl: 2,
          }}
          subheader={<ListSubheader>Slides</ListSubheader>}
        >
          <Divider />
          {map(slideIds, (slideId) => {
            const slideDetails = slideDetailsById?.[slideId];
            const primaryText =
              join(compact([slideDetails?.caseLabel, slideDetails?.originalFileName]), ' / ') || slideId;

            return (
              <ListItem key={slideId}>
                <ListItemText primary={primaryText} secondary={primaryText === slideId ? undefined : slideId} />
              </ListItem>
            );
          })}
        </List>
      </AccordionDetails>
    </Accordion>
  );
};

export default MultiplexProcessSlideIds;
